import useSWR, { type SWRConfiguration } from 'swr';

import { buildQueryKey } from '@common/utils/buildQueryKey';

import {
  getPaymentsHistory,
  type GetPaymentsHistoryParams,
  type GetPaymentsHistoryResponse,
} from '@services/PaymentsService';

export type UseGetPaymentsHistoryParams = {
  queryParams?: GetPaymentsHistoryParams;
  swrOptions?: SWRConfiguration<GetPaymentsHistoryResponse, unknown>;
};

// The params are part of the key — callers with different params must not
// collide on one cache entry.
export const getPaymentsHistoryQueryKey = (
  queryParams?: GetPaymentsHistoryParams,
) => buildQueryKey('get-payments-history', queryParams);

export const useGetPaymentsHistory = ({
  queryParams,
  swrOptions,
}: UseGetPaymentsHistoryParams = {}) => {
  const { data, ...swrResponse } = useSWR<GetPaymentsHistoryResponse>(
    getPaymentsHistoryQueryKey(queryParams),
    () => getPaymentsHistory(queryParams),
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
